<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <section id="problem" class="bg-[var(--color-bg-secondary)] px-5 py-12 md:px-12 md:py-24">
    <div class="mx-auto max-w-[var(--max-w-content)] text-center">
      <h2
        data-reveal
        class="fade-up text-2xl font-medium text-[var(--color-text-primary)] md:text-4xl"
        style="font-family: var(--font-display)"
      >
        {{ t("problem.heading") }}
      </h2>

      <div
        data-reveal
        data-reveal-delay="1"
        class="fade-up mx-auto mt-6 max-w-[600px] space-y-5 text-base leading-[1.7] text-[var(--color-text-secondary)] md:text-lg"
      >
        <p class="italic" style="font-size: 1.125rem">
          {{ t("problem.quote") }}
        </p>
        <p>{{ t("problem.p1") }}</p>
        <p>{{ t("problem.p2") }}</p>
        <p>{{ t("problem.p3") }}</p>
      </div>
    </div>
  </section>
</template>
